import React, { Component } from "react";
import "./Resume.scss";
import "../../App.scss";

/* Import Components */
import BigHeading from "../../components/BigHeading/BigHeading";
import BulletList from "../../components/BulletList/BulletList";
// import DetailedBulletList from "../../components/BulletList/DetailedBulletList";
import Footer from "../../components/Footer/Footer";
import KeyCertification from "../../components/KeyCertification/KeyCertification";
import NameHeader from "../../components/NameHeader/NameHeader";
import NumberedList from "../../components/NumberedList/NumberedList";
import SmallHeading from "../../components/SmallHeading/SmallHeading";
import SideBarNumberedList from '../../components/NumberedList/SideBarNumberedList';

class Front extends Component {
	render() {
		let leadership = require('../../content/leadership.json');
		let personal = require("../../content/personal.json");
		let techstack = require("../../content/techstack.json");
		let work = require("../../content/work.json");

		return (
			<div className="resume">
				<div className="content">
					<section className="main">
						<BigHeading
							iconClass="fa fa-briefcase"
							title="Work Experience"
						/>
						<NumberedList headings={work} spacedFromSecond />
					</section>
					<aside className="sidebar">
						<NameHeader
							firstName={personal[0].firstName}
							lastName={personal[0].lastName}
							title={personal[0].informalTitle}
						/>
						<div className="sidebar-content">
							{/* OBJECTIVE */}
							<SmallHeading
								iconClass="fa fa-file-text-o"
								title="Objective"
							/>
							<div className="objective-text">
								Distinguished Engineer driving technical strategy and innovation across AI-driven security and application security platforms. Specializes in architecting secure generative AI solutions, advancing autonomous security capabilities, and mentoring engineering teams to deliver next-generation security technologies.
							</div>

							{/* KEY CERTIFICATIONS */}
							<SmallHeading
								iconClass="fa fa-university"
								title="Key Certifications"
							/>
							<KeyCertification
								title="Offensive Security Certified Professional (OSCP)"
								date="ISSUED OCT 2016"
								certNum="OS-101-06167"
								subText=""
								paddingBottom="3"
							/>

							{/* COMMUNITY LEADERSHIP */}
							<SmallHeading iconClass='fa fa-file-text'
								title='Community Leadership'/>
							<SideBarNumberedList headings={leadership}/>


							{/* TECHNOLOGY STACK */}
							<SmallHeading
								iconClass="fa fa-code"
								title="Tech Stack Experience"
							/>
							<BulletList bulletList={techstack} alpha />

							{/* CONTRIBUTIONS */}
							{/* <SmallHeading
								iconClass="fa fa-code-fork"
								title="Contributions"
							/>
							<DetailedBulletList
								bulletList={contributions}
								paddedList
							/> */}
						</div>
					</aside>
				</div>
				<Footer />
			</div>
		);
	}
}

export default Front;
